module.exports = __webpack_public_path__ + "static/media/SequenceFlow.749f8ff8.svg";